import axios from '@/axios'

const state = {
    clientPostageSellingPrices: [],
    clientBatchTypes: [],
    tabEnvTypes: [],
};

const getters = {
    getClientPostageSellingPrices: (state) => state.clientPostageSellingPrices,
    getClientBatchTypes: (state) => state.clientBatchTypes,
    getTabEnvTypes: (state) => state.tabEnvTypes,
};

const mutations = {
    setClientPostageSellingPrices: (state, clientPostageSellingPrices) => (state.clientPostageSellingPrices = clientPostageSellingPrices),
    setClientBatchTypes: (state, clientBatchTypes) => (state.clientBatchTypes = clientBatchTypes),
    setTabEnvTypes: (state, tabEnvTypes) => (state.tabEnvTypes = tabEnvTypes),
};

const actions = {
    async loadClientPostageSellingPrices(context, data) {
        await axios().get(`/getClientPostageSellingPrices`, {
            params: {
                client: data.client,
                tabCode: data.tabCode
            }
        }).then(response => {
            context.commit('setClientPostageSellingPrices', response.data.clientPostageSellingPrices)
            context.commit('setClientBatchTypes', response.data.clientBatchTypes)
            context.commit('setTabEnvTypes', response.data.tabEnvTypes)
            context.dispatch('handleResponse', response)
        })
    },
    async updateClientPostageSellingPrice(context, data) {
        await axios().post(`/updateClientPostageSellingPrice`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async deleteClientPostageSellingPrice(context, data) {
        await axios().post(`/deleteClientPostageSellingPrice`, {
            itemId: data.itemId
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async addClientPostageSellingPrice(context, data) {
        await axios().post(`/addClientPostageSellingPrice`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
